/**
 * Lazy Size (Lazy Load Images)
 */

import lazySizes from 'lazysizes';

// Backward compatibility with jQuery LazyLoad
lazySizes['cfg'].lazyClass = 'lazy';
lazySizes['cfg'].srcAttr = 'data-original';